export default __webpack_public_path__ + "static/media/icon6.af3ccfdd.svg";